export default function initTabs() {
    for (const tab of document.querySelectorAll('.tab')) {
        tab.addEventListener('click', () => {
            // Disable tab functionality if the tab has no data-tab, used for buttons as tabs.
            if (!tab.getAttribute('data-tab')) {
                return;
            }

            const parent = tab.parentNode.parentNode;

            for (const tabInner of parent.querySelectorAll('.tab')) {
                tabInner.classList.remove('active');
            }

            for (const tabContent of parent.querySelectorAll('.tab-content')) {
                tabContent.classList.remove('active');
            }

            const content = parent.querySelector('.' + tab.getAttribute('data-tab'));
            tab.classList.add('active');
            content.classList.add('active');
        });
    }
}
